<template>
  <div>
    <div class="contents">
      <BaseHeader title="ログ一覧" />
    </div>
  </div>
</template>

<script>
import BaseHeader from '@/components/molecules/BaseHeader'

export default {
  name: 'Log',
  components: {
    BaseHeader
  },
  created () {
  }
}
</script>
